module.exports = __webpack_public_path__ + "static/icons/icon-mis-seguros-proyeccion-vf.7ee25ee.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons-mis-seguros/icon-mis-seguros-proyeccion-vf.gif
// module id = oWg3
// module chunks = 1